import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Select, Collapse } from "antd";
import { useForm, Controller } from "react-hook-form";
import YFSubmitButton from "../elements/YFSubmitButton";
import { getVehicleMake, getVehicleType } from "../../api";

const SearchForm = ({
  onSearch,
  value,
  title,
  showFilter,
  defaultValues,
  loading,
}) => {
  const { control, handleSubmit, setValue } = useForm({});
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleMakes, setVehicleMakes] = useState([]);
  const [models, setModel] = useState([]);

  const getModel = (id, vehicleMakeList = []) => {
    const list = vehicleMakes?.length === 0 ? vehicleMakeList : vehicleMakes;

    const make = list.filter((item) => id === item.id);
    const models = [];
    if (make.length === 1) {
      models.push({
        id: undefined,
        label: "Any",
        value: undefined,
      });
      make[0].models.forEach((item) => {
        models.push({
          id: item.id,
          label: item.name,
          value: item.id,
        });
      });
    }
    setModel(models);
  };

  const loadVehicleData = useCallback(() => {
    Promise.all([getVehicleMake(), getVehicleType()]).then((responses) => {
      responses.forEach((item) => {
        if (item.vehicle_make) {
          const items = [];
          items.push({
            id: undefined,
            label: "Any",
            value: undefined,
            models: [],
          });
          item.vehicle_make.data.forEach((item) => {
            const { id, make, models } = item;
            const _new_item = {
              id,
              label: make,
              value: id,
              models: models,
            };
            items.push(_new_item);
            setValue("make", value.make);
          });
          setVehicleMakes(items);
          getModel(defaultValues?.make, items);
        }
        if (item.vehicle_type) {
          const items = [];
          items.push({
            id: undefined,
            label: "Any",
            value: undefined,
          });
          item.vehicle_type.data.forEach((item) => {
            const { id, type } = item;
            const _new_item = {
              id,
              label: type,
              value: id,
            };
            items.push(_new_item);
          });
          setVehicleTypes(items);
        }
      });
    });
  }, []);

  useEffect(() => {
    loadVehicleData();
  }, [loadVehicleData]);

  const onSubmit = (data) => {
    onSearch(data);
  };

  return (
    <div className="formStatus find-car-container">
      <form onSubmit={handleSubmit(onSubmit)} className="formStatusInitial">
        {title && <p className="find-car-text">{title}</p>}
        <label htmlFor="country">{"Vehicel Make"}</label>
        <Controller
          name="make"
          as={
            <Select
              id="search-form-make-select"
              showSearch
              className="formOption yf-select drop-down-container"
              style={{ width: "100%" }}
              placeholder="Any"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              defaultValue={defaultValues?.make}
            >
              {vehicleMakes.map((item) => {
                return (
                  <Select.Option value={item.value} key={item.id}>
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
          onChange={([selected, make]) => {
            setValue("model", undefined);
            getModel(selected);
            return selected;
          }}
          rules={{ required: false }}
          control={control}
        />

        <label htmlFor="country">Model</label>
        <Controller
          name="model"
          as={
            <Select
              id="search-form-model-select"
              showSearch
              className="formOption yf-select drop-down-container"
              style={{ width: "100%" }}
              placeholder="Any"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              defaultValue={defaultValues?.model}
            >
              {models.map((item) => {
                return (
                  <Select.Option value={item.value} key={item.id}>
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
          onChange={([selected, model]) => {
            return selected;
          }}
          rules={{ required: false }}
          control={control}
        />

        <label htmlFor="country">Vehicel Type</label>
        <Controller
          name="type"
          as={
            <Select
              showSearch
              id="search-form-type-select"
              className="formOption yf-select drop-down-container"
              style={{ width: "100%" }}
              placeholder="Any"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              defaultValue={defaultValues?.type}
            >
              {vehicleTypes.map((item) => {
                return (
                  <Select.Option value={item.value} key={item.id}>
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
          onChange={([selected]) => {
            // setSateOfCountry(getStateOfCountry(selected));
            return selected;
          }}
          rules={{ required: false }}
          control={control}
        />

        <label htmlFor="country">Number of Seats</label>
        <Controller
          name="seat"
          as={
            <Select
              id="search-form-seat-select"
              showSearch
              className="formOption yf-select drop-down-container"
              style={{ width: "100%" }}
              placeholder="Any"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              defaultValue={defaultValues?.seat}
            >
              {seats.map((item) => {
                return (
                  <Select.Option value={item.value} key={item.id}>
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
          onChange={([selected]) => {
            // setSateOfCountry(getStateOfCountry(selected));
            return selected;
          }}
          rules={{ required: false }}
          control={control}
        />
        {showFilter && (
          <Collapse className="formStatusInitialMoreInfo">
            <Collapse.Panel header="See more filter" key="1">
              <label htmlFor="fuel">Fuel</label>
              <Controller
                name="fuel"
                as={
                  <Select
                    id="search-form-fuel-select"
                    showSearch
                    className="formOption yf-select"
                    style={{ width: "100%" }}
                    placeholder="Any"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {fuels.map((item) => {
                      return (
                        <Select.Option value={item.value} key={item.id}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                }
                onChange={([selected, model]) => {
                  return selected;
                }}
                rules={{ required: false }}
                control={control}
              />

              <label htmlFor="transmission">Transmission</label>
              <Controller
                name="transmission"
                as={
                  <Select
                    id="search-form-transmission-select"
                    showSearch
                    className="formOption yf-select"
                    style={{ width: "100%" }}
                    placeholder="Any"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {tramissions.map((item) => {
                      return (
                        <Select.Option value={item.value} key={item.id}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                }
                onChange={([selected, model]) => {
                  return selected;
                }}
                rules={{ required: false }}
                control={control}
              />

              <label htmlFor="year">Year</label>
              <Controller
                name="year"
                as={
                  <Select
                    id="search-form-year-select"
                    showSearch
                    className="formOption yf-select"
                    style={{ width: "100%" }}
                    placeholder="Any"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {years.map((item) => {
                      return (
                        <Select.Option value={item.value} key={item.id}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                }
                onChange={([selected, model]) => {
                  return selected;
                }}
                rules={{ required: false }}
                control={control}
              />
            </Collapse.Panel>
          </Collapse>
        )}
        <YFSubmitButton test_id="search-form-submit" label="Search" />
      </form>
    </div>
  );
};

SearchForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default SearchForm;

const fuels = [
  {
    label: "Any",
    value: undefined,
  },
  {
    label: "Disel",
    value: "Disel",
  },
  {
    label: "Petrol",
    value: "Petrol",
  },
  {
    label: "Hybrid",
    value: "Hybrid",
  },
  {
    label: "Gas",
    value: "Gas",
  },
  {
    label: "Electric",
    value: "Electric",
  },
];

const tramissions = [
  {
    label: "Any",
    value: undefined,
  },
  {
    label: "Automatic",
    value: "Automatic",
  },
  {
    label: "Manual",
    value: "Manual",
  },
  {
    label: "Semi-Automatic",
    value: "Semi-Automatic",
  },
];

const years = [
  {
    label: "Any",
    value: undefined,
  },
  {
    label: "2018",
    value: "2018",
  },
  {
    label: "2019",
    value: "2019",
  },
  {
    label: "2020",
    value: "2020",
  },
];

const seats = [
  {
    label: "Any",
    value: undefined,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "7",
    value: 7,
  },
];
